export default {
  EditButton: 'Edit',
};
